import { FIELD_TYPE } from 'core/utils/constant';

const key = {
  key: 'Key',
  name: 'Key',
  position: 1,
  type: FIELD_TYPE.text,
};

const name = {
  key: 'Name',
  name: 'Name',
  position: 2,
  type: FIELD_TYPE.text,
};

const table = {
  columns: [key, name],
  rowCount: 10,
  sortByColumnKey: 'Name',
  ascendingSort: true,
  additionalData: { disableViewed: true, disableCache: true },
};

export default table;
